import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { UseMakeSortedSegmentFields } from "../hooks/use-sorted-segment-fields";
import type { Condition } from "../types";
import { OperationSelect } from "./operation-select/operation-select";

export const OperationField: FC<{
  field: ReturnType<UseMakeSortedSegmentFields>["currentField"];
  segmentFields: ReturnType<UseMakeSortedSegmentFields>["fields"];
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  errMsg?: string;
}> = ({ field, condition, handleFieldChange, disabled, errMsg }) => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth error={Boolean(errMsg)}>
      <InputLabel id="operator-label">{t("Operator")}</InputLabel>
      <OperationSelect
        fieldType={field.field.field_type}
        condition={condition}
        handleFieldChange={handleFieldChange}
        disabled={disabled}
      />
      {errMsg && <FormHelperText>{errMsg}</FormHelperText>}
    </FormControl>
  );
};
